<template>
    <div class="team__section">

        <div class="head__text__col" v-bind:style="{ backgroundImage: image_url('left') }">
            <p class="red">OUR</p>
            <p class="white">TEAM</p>
        </div>

        <div class="team__content">
            <div class="mobile__headline">
                <p class="red">OUR</p>
                <p class="white">TEAM</p>
            </div>

            <div class="our__team__details">
                <p class="subline">informations</p>
                <p class="headline">OUR TEAM</p>
                <p class="description">
                    We are a young and up-and-coming collective based in Sarajevo and we are looking to leave our mark in the gaming industry, throughout our short but very successful history we have managed to complete a list of top-notch gaming projects and possess an impeccable track record. Although we strive to apply our technology in various industries, our strong focus is on the gaming industry where we have completed (and are working on) projects for titles such as Outcast 2 - A New Beginning, Alone in the Dark, Gothic Remake, and others. 
                </p>
                <p class="description part-2">
                    Our team is filled with ambitious, hard-working individuals who share our vision and believe in making a positive impact in the industry through sharing knowledge, passion, and creativity in our team as well as in the wider community.
                </p>

                <div class="perks__container">
                    <p class="title">PERKS</p>

                    <perks-slider></perks-slider>
                    
                </div>

                <p class="contact-text">Share Your thought or get in touch with us</p>

                <a class="contact_btn" href="/contact">
                    <p>CONTACT US</p>
                    <div class="span_bg"></div>
                </a>
            </div>

        </div>

        <div class="right__img" v-bind:style="{ backgroundImage: image_url('right') }"></div>

    </div>
</template>
<script>
export default {
    data(){
        return {}
    },
    props: ['left_image', 'right_image'],
    methods: {
        image_url(position){
            if(position === 'left') return "url('" + this.left_image.media_URL + "')"
            if(position === 'right') return "url('" + this.right_image.media_URL + "')"
        }
    }
}
</script>

<style lang="scss" scoped>

    .team__section{
        // background: #5C2D90;
        background: linear-gradient(180deg, #2A1542 0%, #000000 100%);
        // height: calc(100% - 64px);
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: row;

        .head__text__col{
            width: 100%;
            min-width: 640px;
            height: 100%;

            display: flex;
            flex-direction: column;
            justify-content: flex-end;

            // background: url('/images/team/overlay/left.webp') no-repeat;
            // background-position: 0 0;
            background-position: 60% 0;
            background-repeat: no-repeat;
            position: relative;

            &:after{
                content: ' ';
                position: absolute;
                width: 100%;
                height: 100%;
                left: 0;
                right: 0;
                top: 0;
                bottom: 0;
                background-color: rgba(0,0,0,.5);
                z-index: 1;

                border-right: 1px solid #ED1163;
            }


            .red{
                font-family: 'DIN Next LT Pro Medium', Tahoma, Verdana, sans-serif;
                font-style: normal;
                font-weight: 700;
                font-size: 50px;
                line-height: 50px;

                margin:0;
                margin-left: 92px;
                margin-right: 86px;

                color: #ED1163;
                z-index: 2;
            }

            .white{
                font-family: 'DIN Next LT Pro Medium', Tahoma, Verdana, sans-serif;
                font-style: normal;
                font-weight: 500;
                font-size: 150px;
                line-height: 150px;
                
                margin:0;
                margin-left: 92px;
                margin-right: 8px;
                margin-bottom: 64px;

                color: #FFFFFF;
                z-index: 2;
            }
        }

        .team__content{
            width: 100%;
            min-width: 1111px;
            max-width: 1111px;
            // height: 100%;
            height: auto;
            background: linear-gradient(180deg, #2A1542 0%, #000000 100%);

            position: relative;
            overflow-y: hidden;
            padding-top: 92px;
            scroll-behavior: smooth;

            .mobile__headline{
                display: none;
                flex-direction: column;
                border-bottom: 1px solid #ED1163;
                margin-top: 5px;
                margin-bottom: 10px;
                z-index: 1;
                width: calc(100% - 22px);
                margin-left: auto;
                margin-right: auto;

                .red{
                    font-family: 'DIN Next LT Pro Regular', Tahoma, Verdana, sans-serif;
                    font-style: normal;
                    // font-weight: 400;
                    font-size: 14px;
                    line-height: 17px;
                    /* identical to box height */

                    color: #ED1163;
                    margin: 0;
                    margin-right: 11px;
                    margin-left: auto;
                }

                .white{
                    font-family: 'DIN Next LT Pro Bold', Tahoma, Verdana, sans-serif;
                    font-style: normal;
                    font-weight: 700;
                    font-size: 16px;
                    line-height: 19px;

                    color: #FFFFFF;
                    margin: 0;
                    margin-right: 11px;
                    margin-left: auto;
                }
            }

            .our__team__details{
                display: flex;
                flex-direction: column;
                padding: 0 110px;
                margin-top: 53px;

                .subline{
                    font-family: 'DIN Next LT Pro Bold', Tahoma, Verdana, sans-serif;
                    font-style: normal;
                    // font-weight: 700;
                    font-size: 18px;
                    line-height: 22px;
                    text-align: left;

                    color: #ED1163;
                    margin: 0;
                }

                .headline{
                    font-family: 'DIN Next LT Pro Bold', Tahoma, Verdana, sans-serif;
                    font-style: normal;
                    // font-weight: 700;
                    font-size: 50px;
                    line-height: 60px;
                    text-align: left;

                    color: #FFFFFF;
                    margin: 0;
                    // margin-bottom: 30px;
                    margin-bottom: 20px;
                    margin-left: -2px;
                }

                .description{
                    font-family: 'DIN Next LT Pro UltraLight', Tahoma, Verdana, sans-serif;
                    font-style: normal;
                    font-weight: 300;
                    font-size: 18px;
                    line-height: 22px;

                    color: #FFFFFF;
                    margin: 0;

                    &.part-2{
                        margin-top: 22px;
                    }
                }

                .perks__container{
                    display: flex;
                    flex-direction: column;

                    margin-top: 38px;

                    .title{
                        font-family: 'DIN Next LT Pro Bold', Tahoma, Verdana, sans-serif;
                        font-style: normal;
                        // font-weight: 700;
                        font-size: 20px;
                        line-height: 24px;

                        color: #FFFFFF;
                        margin: 0;
                        margin-bottom: 35px;
                    }
                }

                .contact-text{
                    font-family: 'DIN Next LT Pro UltraLight', Tahoma, Verdana, sans-serif;
                    font-style: normal;
                    // font-weight: 300;
                    font-size: 18px;
                    line-height: 22px;
                    text-align: center;
                    color: #FFFFFF;
                    margin: 0;
                    margin-top: 40px;
                    margin-bottom: 24px;
                }

                a.contact_btn{
                    display: block;
                    background: rgba(0, 0, 0, 0.6);
                    border: 1px solid #ED1163;
                    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
                    width: 246px;
                    height: 45px;
                    cursor: pointer;
                    user-select: none;
                    position: relative;
                    overflow-y: hidden;
                    z-index: 4;
                    text-decoration: none;
                    margin-left: auto;
                    margin-right: auto;

                    p{
                        font-family: 'DIN Next LT Pro Bold', Tahoma, Verdana, sans-serif;
                        font-style: normal;
                        // font-weight: 700;
                        font-size: 18px;
                        line-height: 48px;

                        text-align: center;

                        color: #FFFFFF;
                        margin: 0 auto;

                        color: #FFFFFF;
                        position: relative;
                        z-index: 4;
                    }

                    div.span_bg{
                        background: linear-gradient(90deg, #ED1163 0%, #5C2C90 96.27%);
                        height: 100%;
                        width: 100%;
                        transition: all .3s ease-in-out;
                        margin-top: auto;
                        margin-bottom: 0;
                        opacity: 0;

                        position: absolute;
                        bottom: -50px;
                        z-index: 3;
                    }

                    &:hover{
                        div.span_bg{
                            height: calc(100%);
                            bottom: 0;
                            opacity: 1;
                        }
                    }
                }                
            }

        }

        .right__img{
            min-width: 168px;
            height: 100%;

            // background: url('/images/team/overlay/right.webp') no-repeat;
            background-position: top;
            background-repeat: no-repeat;
            position: relative;

            margin-left: auto;
            margin-right: 0;
            border-left: 1px solid #ED1163;
        }

        .mobile__team-section{
            display: none;
            background: linear-gradient(0deg, rgba(0, 0, 0, 0.75), rgba(0, 0, 0, 0.75));

            
            .overlay{
                background: url('/images/team/overlay/mobile_team_overlay.webp') no-repeat;
                background-position: 0 0;
                background-repeat: no-repeat;
                position: relative;
                height: 100%;
                width: 100%;
                background-position-x: 150%;
                // opacity: 0.3;
                background-position-x: 75%;
            }

            .text{
                display: flex;
                flex-direction: column;
                padding: 4px 11px;

                .subline{
                    font-family: 'DIN Next LT Pro Regular', Tahoma, Verdana, sans-serif;
                    font-style: normal;
                    // font-weight: 400;
                    font-size: 14px;
                    line-height: 17px;
                    /* identical to box height */

                    color: #ED1163;
                    margin: 0;
                    margin-left: auto;
                    margin-right: 0;
                }

                .headline{
                    font-family: 'DIN Next LT Pro Bold', Tahoma, Verdana, sans-serif;
                    font-style: normal;
                    // font-weight: 700;
                    font-size: 16px;
                    line-height: 19px;
                    color: #FFFFFF;

                    margin: 0;
                    margin-left: auto;
                    margin-right: 0;
                }

                .divider{
                    width: 100%;
                    height: 1px;
                    background: #ED1163;
                }

                .small-bold{
                    font-family: 'DIN Next LT Pro Regular', Tahoma, Verdana, sans-serif;
                    font-style: normal;
                    // font-weight: 700;
                    font-size: 12px;
                    line-height: 14px;
                    color: #FFFFFF;
                    margin: 0;
                    margin-top: 10px;
                }

                .title{
                    font-family: 'DIN Next LT Pro Bold', Tahoma, Verdana, sans-serif;
                    font-style: normal;
                    font-weight: 700;
                    font-size: 25px;
                    line-height: 30px;

                    color: #FFFFFF;
                    margin: 0;
                    margin-bottom: 10px;

                    &.mt-5{
                        margin-top: 52px;
                    }
                }

                .description{
                    font-family: 'DIN Next LT Pro Ultralight', Tahoma, Verdana, sans-serif;
                    font-style: normal;
                    // font-weight: 300;
                    font-size: 14px;
                    line-height: 17px;

                    color: #FFFFFF;
                    margin: 0;
                }

                .read-more-link{
                    font-family: 'DIN Next LT Pro Bold', Tahoma, Verdana, sans-serif;
                    font-style: normal;
                    font-weight: 700;
                    font-size: 14px;
                    line-height: 17px;
                    text-align: center;

                    margin-top: 66px;
                    margin-bottom: 66px;
                    text-decoration: none;

                    color: #FFFFFF;
                }
            }

        }
    }


    @media screen and (max-width: 1750px) {
        .team__section{

            .head__text__col{
                width: 100%;
                min-width: 168px;

                .red, .white{
                    display: none;
                }
            }

        }
    }

    @media screen and (max-width: 1450px) {
        .team__section{
            
            .head__text__col{
                min-width: initial;
            }

            .right__img{
                width: 100%;
                min-width: initial;
            }

        }
    }


    @media screen and (max-width: 836px) {

        .team__section{
            flex-direction: column;

            .head__text__col, .right__img{
                display: none;
            }

            .team__content{
                min-width: initial;
                max-width: initial;
                height: auto;
                overflow: initial;
                padding: 0;
                background: linear-gradient(180deg, #31174D 0%, #000000 100%);

                .mobile__headline{
                    display: flex;
                }

                .our__team__details{
                    padding: 0 21px;
                    margin-top: 0;

                    .subline{
                        color: #fff;
                        font-size: 12px;
                        line-height: 14px;
                    }

                    .headline{
                        font-size: 25px;
                        line-height: 30px;
                    }
                
                    .description{
                        font-size: 14px;
                        line-height: 17px;
                    }

                    .contact-text{
                        font-size: 16px;
                        line-height: 19px;
                    }

                    a.contact_btn{
                        margin-bottom: 40px;

                        height: 31px;

                        p{
                            font-size: 12px;
                            line-height: 33px;
                        }

                        width: calc(100% - 40px);
                    }
                }   
            }
        }

    }

    @media screen and (min-width: 836px) and (max-height: 900px) {
        .team__section{

            .team__content{

                .our__team__details{

                    .headline{
                        margin-bottom: 0;
                    }

                    .perks__container{
                        margin-top: 18px;

                        .title{
                            margin-bottom: 8px;
                        }

                    }

                    .contact-text{
                        margin-top: 12px;
                        margin-bottom: 12px;
                    }

                }

            }

        }
    }

</style>